"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMINDER_ACTIONS = void 0;
var REMINDER_ACTIONS;
(function (REMINDER_ACTIONS) {
    REMINDER_ACTIONS["REMIND_AGAIN"] = "REMIND_AGAIN";
    REMINDER_ACTIONS["REVOKE"] = "REVOKE";
})(REMINDER_ACTIONS || (exports.REMINDER_ACTIONS = REMINDER_ACTIONS = {}));
